export enum StorageKeys {
    API_TOKEN = 'API_TOKEN',
}
